// Display formatting for the device OS version reported by the mobile app.
//
// The API stores these as two separate fields — `platform` ('ios' | 'android')
// and `osVersion` (a bare version string like '18.3.1' or '14') — so that both
// are independently filterable and the version sorts sensibly. For display we
// recombine them into the form people actually read: "iOS 18.3.1".

const PLATFORM_LABELS: Record<string, string> = {
    ios: 'iOS',
    android: 'Android',
};

export const formatOsVersion = (
    platform?: string,
    osVersion?: string,
): string => {
    if (!osVersion) return 'N/A';

    // Unknown/absent platform: still show the version rather than hiding data.
    // An unrecognised platform value is passed through as-is instead of being
    // dropped, so a future platform shows up in the UI rather than silently
    // rendering as a bare number.
    if (!platform) return osVersion;

    const label = PLATFORM_LABELS[platform] ?? platform;
    return `${label} ${osVersion}`;
};
